import type { RouteRecordRaw } from 'vue-router';

/**
 * Quality Management web screens (M8, DECISIONS.md "ADR-087 — Quality Management (M8, WP8.4)").
 * Follows the parallel-work convention established by `procurement.ts`/`planning.ts` — `router.ts`
 * only spreads this array into the app-shell `children`. The textile pack's shade-approval monitor
 * lives under `routes/textile.ts` instead (industry-pack screens are grouped with the rest of that
 * pack's routes, matching where `RollGradesPage.vue`/`ShadeLotPage.vue`-style screens already live).
 */
export const qualityRoutes: RouteRecordRaw[] = [
  {
    path: 'quality/plans',
    name: 'quality-plans',
    component: () => import('../pages/quality/InspectionPlansPage.vue'),
    meta: { requiresModule: 'quality' },
  },
  {
    path: 'quality/plans/:id',
    name: 'quality-plan-detail',
    component: () => import('../pages/quality/InspectionPlanDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'quality' },
  },
  {
    path: 'quality/lots',
    name: 'quality-lots',
    component: () => import('../pages/quality/InspectionLotsPage.vue'),
    meta: { requiresModule: 'quality' },
  },
  {
    path: 'quality/lots/:id',
    name: 'quality-lot-detail',
    component: () => import('../pages/quality/InspectionLotDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'quality' },
  },
  {
    path: 'quality/ncrs',
    name: 'quality-ncrs',
    component: () => import('../pages/quality/NcrsPage.vue'),
    meta: { requiresModule: 'quality' },
  },
  {
    path: 'quality/ncrs/:id',
    name: 'quality-ncr-detail',
    component: () => import('../pages/quality/NcrDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'quality' },
  },
];
